module.exports = __webpack_public_path__ + "img/i1.3665296c.png";